import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh, faPrint } from "@fortawesome/free-solid-svg-icons";

interface DashboardHeaderProps {
  title: string;
  subtitle: string;
  onRefresh: () => void;
  onPrint: () => void;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  title,
  subtitle,
  onRefresh,
  onPrint
}) => {
  return (
    <div className="bg-gradient-to-r from-blue-700 to-blue-500 text-white py-4 px-6 rounded-lg shadow-md">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
        <div>
          <h1 className="text-2xl font-bold mb-2">{title}</h1>
          <p className="text-blue-100">{subtitle}</p>
        </div>
        <div className="flex flex-wrap gap-3 mt-4 md:mt-0">
          <button
            onClick={onRefresh}
            className="flex items-center gap-2 bg-white/20 hover:bg-white/30 px-4 py-2 rounded-lg transition-all"
          >
            <FontAwesomeIcon icon={faRefresh} />
            <span className="hidden sm:inline">Refresh Data</span>
          </button>
          {/* <button
            onClick={onPrint}
            className="flex items-center gap-2 bg-white/20 hover:bg-white/30 px-4 py-2 rounded-lg transition-all"
          >
            <FontAwesomeIcon icon={faPrint} />
            <span className="hidden sm:inline">Generate  Report</span>
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default DashboardHeader;
